<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import NestedQuote from '$lib/Components/Layout/NestedQuote/NestedQuote.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	let { story } = $props();
	const {
		quote,
		name,
		image,
		url = null,
		title = 'Customer Stories',
		body = '',
	} = story;
</script>

<Section backgroundColor="grey-light" class="pb-0">
	<div class="!col-span-full w-full">
		<div class="content-grid relative z-10 mx-auto max-w-xl">
			<h2 class="text-indow-grey-dark text-left">
				{title}
			</h2>
			{#if body}
				<p class="text-indow-grey-dark text-left">
					{body}
				</p>
			{/if}

			<NestedQuote {quote} {name} class="bg-indow-white relative !-mb-30" />
		</div>

		<div
			class="relative grid grid-cols-1 grid-rows-1 [&_>*]:col-span-full [&_>*]:row-span-full"
		>
			<Image src={image} class="h-80 max-w-full" />

			{#if url}
				<div class="mb-8 flex items-end">
					<Button class="shadow-lg" href={url} color="white">READ MORE</Button>
				</div>
			{/if}
		</div>
	</div>
</Section>
